import { render, staticRenderFns } from "./LevelCard.vue?vue&type=template&id=fdd65e78&scoped=true&"
import script from "./LevelCard.vue?vue&type=script&lang=ts&"
export * from "./LevelCard.vue?vue&type=script&lang=ts&"
import style0 from "./LevelCard.vue?vue&type=style&index=0&id=fdd65e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd65e78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fdd65e78', component.options)
    } else {
      api.reload('fdd65e78', component.options)
    }
    module.hot.accept("./LevelCard.vue?vue&type=template&id=fdd65e78&scoped=true&", function () {
      api.rerender('fdd65e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPathV2/LevelCard.vue"
export default component.exports